var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99972 1.99997C4.68601 1.99997 1.99972 4.68625 1.99972 7.99997C1.99972 11.3137 4.68601 14 7.99972 14C11.3134 14 13.9997 11.3137 13.9997 7.99997C13.9997 4.68625 11.3134 1.99997 7.99972 1.99997ZM1.14258 7.99997C1.14258 4.21311 4.21286 1.14282 7.99972 1.14282C11.7866 1.14282 14.8569 4.21311 14.8569 7.99997C14.8569 11.7868 11.7866 14.8571 7.99972 14.8571C4.21286 14.8571 1.14258 11.7868 1.14258 7.99997ZM5.14258 5.99997C5.14258 5.77264 5.23288 5.55462 5.39363 5.39387C5.55438 5.23313 5.77239 5.14282 5.99972 5.14282H9.99972C10.227 5.14282 10.4451 5.23313 10.6058 5.39387C10.7666 5.55462 10.8569 5.77264 10.8569 5.99997V9.99997C10.8569 10.2273 10.7666 10.4453 10.6058 10.6061C10.4451 10.7668 10.227 10.8571 9.99972 10.8571H5.99972C5.77239 10.8571 5.55438 10.7668 5.39363 10.6061C5.23288 10.4453 5.14258 10.2273 5.14258 9.99997V5.99997Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.d50d59aec833f91934d53ef5d0540855.svg";
export { ForwardRef as ReactComponent };